module.exports = [
	{
		"ID": 33,
		"circle": "Kreis 1",
		"name": "Rathaus"
	},
	{
		"ID": 41,
		"circle": "Kreis 1",
		"name": "Hochschulen"
	},
	{
		"ID": 51,
		"circle": "Kreis 1",
		"name": "Lindenhof"
	},
	{
		"ID": 62,
		"circle": "Kreis 1",
		"name": "City"
	},
	{
		"ID": 84,
		"circle": "Kreis 2",
		"name": "Wollishofen"
	},
	{
		"ID": 95,
		"circle": "Kreis 2",
		"name": "Leimbach"
	},
	{
		"ID": 106,
		"circle": "Kreis 2",
		"name": "Enge"
	},
	{
		"ID": 128,
		"circle": "Kreis 3",
		"name": "Wiedikon"
	},
	{
		"ID": 139,
		"circle": "Kreis 3",
		"name": "Friesenberg"
	},
	{
		"ID": 150,
		"circle": "Kreis 3",
		"name": "Sihlfeld"
	},
	{
		"ID": 172,
		"circle": "Kreis 4",
		"name": "Werd"
	},
	{
		"ID": 183,
		"circle": "Kreis 4",
		"name": "Langstrasse"
	},
	{
		"ID": 194,
		"circle": "Kreis 4",
		"name": "Hard"
	},
	{
		"ID": 216,
		"circle": "Kreis 5",
		"name": "Gewerbeschule"
	},
	{
		"ID": 227,
		"circle": "Kreis 5",
		"name": "Escher Wyss"
	},
	{
		"ID": 249,
		"circle": "Kreis 6",
		"name": "Unterstrass"
	},
	{
		"ID": 260,
		"circle": "Kreis 6",
		"name": "Oberstrass"
	},
	{
		"ID": 282,
		"circle": "Kreis 7",
		"name": "Fluntern"
	},
	{
		"ID": 293,
		"circle": "Kreis 7",
		"name": "Hottingen"
	},
	{
		"ID": 304,
		"circle": "Kreis 7",
		"name": "Hirslanden"
	},
	{
		"ID": 315,
		"circle": "Kreis 7",
		"name": "Witikon"
	},
	{
		"ID": 336,
		"circle": "Kreis 8",
		"name": "Seefeld"
	},
	{
		"ID": 347,
		"circle": "Kreis 8",
		"name": "Mühlebach"
	},
	{
		"ID": 358,
		"circle": "Kreis 8",
		"name": "Weinegg"
	},
	{
		"ID": 380,
		"circle": "Kreis 9",
		"name": "Albisrieden"
	},
	{
		"ID": 391,
		"circle": "Kreis 9",
		"name": "Altstetten"
	},
	{
		"ID": 413,
		"circle": "Kreis 10",
		"name": "Höngg"
	},
	{
		"ID": 424,
		"circle": "Kreis 10",
		"name": "Wipkingen"
	},
	{
		"ID": 446,
		"circle": "Kreis 11",
		"name": "Affoltern"
	},
	{
		"ID": 457,
		"circle": "Kreis 11",
		"name": "Oerlikon"
	},
	{
		"ID": 468,
		"circle": "Kreis 11",
		"name": "Seebach"
	},
	{
		"ID": 490,
		"circle": "Kreis 12",
		"name": "Saatlen"
	},
	{
		"ID": 501,
		"circle": "Kreis 12",
		"name": "Schwamendingen-Mitte"
	},
	{
		"ID": 512,
		"circle": "Kreis 12",
		"name": "Hirzenbach"
	}
];


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./src/components/identificator/data/cityData.json
// module id = 254
// module chunks = 0